import { Route, Routes } from 'react-router-dom';

import { BrowserExtension } from '../browserExtension';
import { Candidates } from '../candidates';
import { DataPrivacy } from '../dataPrivacy';
import Jobs from '../jobs/Jobs';
import { PaymentIntegration } from '../paymentIntegration';
import { TeamOwners } from '../teamOwners';

export const HelpAndKnowledgeRoutes = () => (
  <Routes>
    <Route path="/faq" element={<Jobs />} />
    <Route path="/faq-candidates" element={<Candidates />} />
    <Route path="/faq-data-privacy" element={<DataPrivacy />} />
    <Route path="/faq-browser-extension" element={<BrowserExtension />} />
    <Route path="/faq-team-owners" element={<TeamOwners />} />
    <Route path="/faq-payment-integration" element={<PaymentIntegration />} />
  </Routes>
);
